module.exports = __webpack_public_path__ + "media/images/flags/AE-46a5698947da4319cd29d95ef4f0b6a9.svg";